﻿// import { quicksearch } from "../quickSearch";
import { initApplicationLibrary } from "./applibrary";

/*
export function initSearchBox(context) {
	context ??= document;
	const searchBox = context.querySelector("#td-mysearchbox");
	if(searchBox) {
		const options = { selector: ".v3-tableview", children: ":scope > tbody > tr", suppressEnter: true };
		if(context.querySelector(options.selector)) {
			quicksearch(searchBox, options);
		} else {
			searchBox.disabled = true;
			searchBox.nextElementSibling.disabled = true;
		}
	}
}
*/

export function init(context) {
	context ??= document;
	// initSearchBox(context);
	initApplicationLibrary(context);
}